import React from 'react';

const getPhoneId = phone => {
  var phoneId = phone
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/ /g, '');
  return `tel://${phoneId}`;
};

export function Phone(props) {
  return props.phone ? (
    <a href={getPhoneId(props.phone)}>{props.phone}</a>
  ) : (
    'не указан'
  );
}

export default Phone;
